<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="getData"
            :search="search"
            :expanded.sync="expanded"
            :single-expand="singleExpand"
            item-key="nr"
            class="elevation-1"
            @click:row="expandRow"
          >
            <template v-slot:top>
              <v-toolbar flat :color="$store.getters.stdColorLight">
                <v-icon>{{ data2Icon }}</v-icon>
                <v-toolbar-title>{{ $t("wgruppe.title") }}</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                >
                </v-divider>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  :label="$t('message.filter')"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" persistent max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-btn class="white--text" :color="$store.getters.stdColorDark" v-on="on">{{ $t("message.newTitle") }}</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <v-toolbar flat :color="$store.getters.stdColorLight">
                        <v-row justify="center">
                          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                        </v-row>
                      </v-toolbar>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row dense no-gutters>
                          <v-col cols="4">
                            <v-text-field disabled v-model="editedItem.nr" :label="$t('wgruppe.nr')"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense no-gutters>
                          <v-col cols="12">
                            <v-text-field v-model="editedItem.text" :label="$t('wgruppe.text')" max="31" counter="31" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn :disabled="checkNavigation('prior')" class="white--text" :color="$store.getters.stdColorDark" text @click="prior()">{{ $t("message.prior") }}</v-btn>
                      <v-btn :disabled="checkNavigation('next')" class="white--text" :color="$store.getters.stdColorDark" text @click="next()">{{ $t("message.next") }}</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn class="white--text" :color="$store.getters.stdColorDark" text @click="close()">{{ $t("message.cancel") }}</v-btn>
                      <v-btn class="white--text" :color="$store.getters.stdColorDark" text @click="save(true)">{{ $t("message.save") }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:item="{ item }">
              <tr :bgcolor="customRowClass(item)">
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small class="mr-2" v-on="on" @click="editItem(item)">mdi-pencil</v-icon>
                    </template>
                    <span>{{ $t("tooltip.edit") }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small v-on="on" @click="deleteItem(item)">mdi-delete</v-icon>
                    </template>
                    <span>{{ $t("tooltip.delete") }}</span>
                  </v-tooltip>
                </td>
                <td style="text-align:right">{{item.nr}}</td>
                <td>{{item.text}}</td>
              </tr>
            </template>

          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import WebService from "@/plugins/WebService";
import { mdiCircleSlice2 } from '@mdi/js'

export default {
  name: "wgruppe-table",

  components: {
  },

  data() {
    return {
      data2Icon: mdiCircleSlice2,
      
      webService: new WebService(this),

      dialog: false,

      editedIndex: -1,
      editedItem: {
        mid: '',
        nr: 0,
        text: ''
      },
      defaultItem: {
        mid: '',
        nr: 0,
        text: ''
      },

      //table
      expanded: [],
      singleExpand: true,
      search: ''
    };
  },

  created() {
    this.$store.watch(
      function(state) {
        return state.wgruppenList;
      },
      () => {
        //collapse all rows on data change
        this.expanded = [];
      },
      {
        deep: true //add this if u need to watch object properties change etc.
      }
    );
  },

  computed: {
    getData() {
      return this.$store.getters.wgruppenList;
    },

    headers() {
      return [
        {
          text: this.$t("message.actions"),
          value: 'actions',
          sortable: false
        },
        {
          text: this.$t("wgruppe.nr"),
          class: "blue-grey--text",
          align: "right",
          sortable: true,
          value: "nr"
        },
        {
          text: this.$t("wgruppe.text"),
          class: "blue-grey--text",
          sortable: true,
          value: "text"
        },
        { text: "", value: "data-table-expand" }
      ];
    },

    formTitle () {
      return this.editedIndex === -1 ? this.$t("message.newTitle") : this.$t("message.editTitle")
    }
  },

  methods: {
    customRowClass(item) {
      if (item==null)
        return ''

      if (this.editedIndex>=0)
      {
        return item.nr === this.editedItem.nr ? this.$store.getters.stdColorSelectedRow : ''
      }
      else
        return ''
    },

    expandRow(item) {
      /* eslint-disable no-console */
      //console.log(item.artnr)
      this.expanded = item === this.expanded[0] ? [] : [item];
    },

    editItem(item)
    {
      this.editedIndex = this.$store.getters.wgruppenList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item)
    {
      //delete item
      this.$store.dispatch("setConfirmDialog", { showConfirmDialog: true, message: this.$t("message.confirmDelete"), action: "deleteWgruppeRecord", params: [item] });
    },

    close()
    {
      this.dialog=false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)      
    },

    save(closeOnSave)
    {
      if (this.editedIndex > -1) {
        this.webService.updateItem(this.$store.getters.wgruppenBase, this.editedItem, [this.editedItem.nr])
          .then(response => {
            if (response.request.status==200)
            {
              if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
              {
                //re-read wgruppen data
                this.webService.getItems(this.$store.getters.wgruppenBase)
                  .then(response => {
                    this.$store.dispatch("setWgruppenList", response.data);
                  })
                  .catch(err => { console.log(err) });
              }
              else
              {
                this.$store.dispatch("setErrorDialog", { sqlCode: response.data.sqlCode, sqlState: response.data.sqlState, sqlMessage: response.data.sqlMessage, myErrorCode: response.data.myErrorCode, showErrorDialog: true });
              }
            }
          })
          .catch(err => { console.log(err) });
      } else {
        this.webService.insertItem(this.$store.getters.wgruppenBase, this.editedItem)
          .then(response => {
            if (response.request.status==201)
            {
              if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
              {
                //re-read wgruppen data
                this.webService.getItems(this.$store.getters.wgruppenBase)
                  .then(response => {
                    this.$store.dispatch("setWgruppenList", response.data);
                  })
                  .catch(err => { console.log(err) });
              }
              else
              {
                this.$store.dispatch("setErrorDialog", { sqlCode: response.data.sqlCode, sqlState: response.data.sqlState, sqlMessage: response.data.sqlMessage, myErrorCode: response.data.myErrorCode, showErrorDialog: true });
              }
            }
          })
          .catch(err => { console.log(err) });
      }      
      if (closeOnSave)
        this.close();
    },

    prior()
    {
      this.save(false)
      this.editedIndex--
      this.editedItem = Object.assign({}, this.$store.getters.wgruppenList[this.editedIndex])
    },

    next()
    {
      this.save(false)
      this.editedIndex++
      this.editedItem = Object.assign({}, this.$store.getters.wgruppenList[this.editedIndex])
    },

    checkNavigation(mode)
    {
      //new record
      if (this.editedIndex==-1)
        return true
      if (mode=='prior')
      {
        return !(this.editedIndex>0)
      }
      else
      {
        return !(this.editedIndex<(this.$store.getters.wgruppenList.length-1))
      }
    }

  },

  watch: {
    expanded: {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        if (newVal.length>0)
        {
          // do something when row is expanded, probably re-read some data
        }
      }
    },

    dialog (val) {
      val || this.close()
    }
  }

};
</script>

<style scoped>
.large-slider >>> .v-slider {
  height: 60px;
}
</style>
